import part107Img from "url:../img/part107.png";
import realApertureImg from "url:../img/real_aperture_100x100.png";
import mugShotImg from "url:../img/mug_shot_100x100.png";
import View from "./view.js";

class TabView extends View {
  _parentElement = document.querySelector(".operations");
  _errorMessage = "No recipes found for your query. Please try again!";
  _message = "";

  // Pub Sub Pattern
  addHandlerRender(handler) {
    ["hashchange", "load"].forEach((ev) =>
      window.addEventListener(ev, handler)
    );
  }

  addHandlerTabs(handler) {
    this._parentElement.addEventListener("click", function (e) {
      const clicked = e.target.closest(".operations__tab");
      if (!clicked) return;

      // Remove active classes
      const tabs = clicked
        .closest(".operations__tab-container")
        .querySelectorAll(".operations__tab");
      tabs.forEach((tab) => tab.classList.remove("operations__tab--active"));

      const contents = this.querySelectorAll(".operations__content");
      contents.forEach((content) =>
        content.classList.remove("operations__content--active")
      );

      // Activate tab and content
      clicked.classList.add("operations__tab--active");
      document
        .querySelector(`.operations__content--${clicked.dataset.tab}`)
        .classList.add("operations__content--active");
    });

    handler();
  }

  _generateMarkup() {
    return `
      <div class="operations__tab-container">
        <button
          class="btn operations__tab operations__tab--1 operations__tab--active"
          data-tab="1"
        >
          <span>01</span>Certified
        </button>
        <button class="btn operations__tab operations__tab--2" data-tab="2">
          <span>02</span>Precision
        </button>
        <button class="btn operations__tab operations__tab--3" data-tab="3">
          <span>03</span>Piloting
        </button>
      </div>
      <div
        class="operations__content operations__content--1 operations__content--active"
      >
        <div class="operations__icon">
          <img
            src="${part107Img}"
            width="100px"
            height="100px"
            alt="pilots"
          />
        </div>
        <h5 class="operations__header">All pilots are Part 107 certified.</h5>
        <p>
          We talk in-depth to identify your needs and your goals that you want
          to achieve with video
        </p>
      </div>

      <div class="operations__content operations__content--2">
        <div class="operations__icon">
          <img
            src="${realApertureImg}"
            width="100px"
            height="100px"
            alt="pilots"
          />
        </div>
        <h5 class="operations__header">Precision</h5>
        <p>
          We present a range of video options that align with your specific
          requests, ensuring a perfect fit for your needs
        </p>
      </div>

      <div class="operations__content operations__content--3 circle_img">
        <div class="operations__icon">
          <img
            src="${mugShotImg}"
            width="100px"
            height="100px"
            alt="pilots"
          />
        </div>
        <h5 class="operations__header">Piloting</h5>
        <p>
          From concept to completion, we provide end-to-end coordination to
          ensure your vision is realized seamlessly.
        </p>
      </div>
    `;
  }

  // Tabbed Component
  runScript() {
    const modal = document.querySelector(".modal");
    const overlay = document.querySelector(".overlay");
    const btnCloseModal = document.querySelector(".btn--close-modal");
    const btnsOpenModal = document.querySelectorAll(".btn--show-modal");

    const openModal = function () {
      modal.classList.remove("hidden");
      overlay.classList.remove("hidden");
    };

    const closeModal = function () {
      modal.classList.add("hidden");
      overlay.classList.add("hidden");
    };

    btnsOpenModal.forEach((btns) => btns.addEventListener("click", openModal));

    btnCloseModal.addEventListener("click", closeModal);
    overlay.addEventListener("click", closeModal);

    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && !modal.classList.contains("hidden")) {
        closeModal();
      }
    });
  }
}

export default new TabView();
